import { Trophy, PhoneOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '../../../core/badge';
import type { SessionSummary } from './conversational-exercise-types';
import { formatDate } from './conversational-exercise-types';

interface SessionHistoryListProps {
  sessions: SessionSummary[];
  onSelect: (session: SessionSummary) => void;
}

export function SessionHistoryList({ sessions, onSelect }: SessionHistoryListProps) {
  const { t } = useTranslation('p2e');
  return (
    <div className="space-y-2 rounded-[16px] border border-rose-100 bg-white p-3">
      {sessions.map((session) => {
        const interrupted = Boolean(session.evaluation?.recovered);
        return (
          <button
            key={session.sessionId}
            onClick={() => onSelect(session)}
            className="w-full flex items-center justify-between p-3 rounded-xl bg-rose-50/50 hover:bg-rose-100/50 transition text-left"
          >
            <div className="flex items-center gap-3">
              <div
                className={
                  interrupted
                    ? 'flex h-10 w-10 items-center justify-center rounded-full bg-slate-300'
                    : 'flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#cf2e2e] to-[#f78da7]'
                }
              >
                {interrupted ? (
                  <PhoneOff className="h-5 w-5 text-white" />
                ) : (
                  <Trophy className="h-5 w-5 text-white" />
                )}
              </div>
              <div>
                <p className="text-sm font-medium text-gray-800">
                  {session.startedAt ? formatDate(session.startedAt) : 'Unknown date'}
                </p>
                <p className="text-xs text-gray-500">
                  {interrupted ? t('zine.speak.historyInterrupted') : t('zine.speak.historyCompleted')}
                </p>
              </div>
            </div>
            {session.score !== undefined && session.score !== null && (
              <Badge className="bg-gradient-to-r from-[#cf2e2e] to-[#f05f7a] text-white border-0">
                {session.score}/{session.maxScore ?? 100}
              </Badge>
            )}
          </button>
        );
      })}
    </div>
  );
}
